// extracted by mini-css-extract-plugin
export var body = "_22-8";
export var button = "_22-0";
export var closeButton = "_22-5";
export var content = "_22-3";
export var empty = "_22-f";
export var grid = "_22-c";
export var header = "_22-4";
export var icon = "_22-1";
export var option = "_22-d";
export var optionSelected = "_22-e";
export var overlay = "_22-2";
export var searchIcon = "_22-a";
export var searchInput = "_22-b";
export var searchWrapper = "_22-9";
export var title = "_22-6";
export var visuallyHidden = "_22-7";